import memoize from 'memoize-one';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { studySessionFreeEnrolled } from 'my-core/gtm-events';

import DialogResponsive from 'my-elements/DialogResponsive';

import { StudySessionCheckoutConfirmation } from './StudySessionCheckout';

function StudySessionFreeConfirmationDialog({ onClose, onExited, open, studySessionUserId: ssuId }) {
  const studySession = useSelector(state =>
    getStudySession(ssuId, state.studySessionUsers.items, state.studySessions.items, state.courses.items),
  );
  // state => ssuId && state.studySessions.items[state.studySessionUsers.items[ssuId]?.study_session_id]
  // );

  useEffect(() => {
    if (open) studySessionFreeEnrolled(studySession);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <DialogResponsive
      fullWidth
      onClose={onClose}
      open={open}
      slotProps={{ transition: { onExited } }}
      sx={{ '& .MuiDialog-paper': { py: 3 } }}
    >
      <StudySessionCheckoutConfirmation onClose={onClose} studySession={studySession} titleVariant="h4" />
    </DialogResponsive>
  );
}

const getStudySession = memoize((ssuId, ssus, sss, courses) => {
  if (ssuId) {
    const ssu = ssus[ssuId];
    const ss = sss[ssu?.study_session_id];
    const course = courses[ssu?.course_id];
    return { ...ss, course };
  }
});

export default StudySessionFreeConfirmationDialog;
